import React from 'react';
import CoverImageSecond from './CoverImageSecond';
import Service12 from './Service12';
import Service12Second from './Service12Second';
import ReservationForm from './ReservationForm';


import Footer from './Footer';


const BYOC = () => {
    return (
        <div>
            <CoverImageSecond />
            <Service12 />
            <Service12Second />

            <ReservationForm />

            <Footer/>

        </div>
    );
};

export default BYOC;